/**
 * @generated SignedSource<<d62e62b6042768cc7051fb397b6890dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductItem_viewer$data = {
  readonly user: {
    readonly email: string | null | undefined;
    readonly firstName: string | null | undefined;
    readonly fullName: string | null | undefined;
    readonly id: string;
    readonly role: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ProductItem_viewer";
};
export type ProductItem_viewer$key = {
  readonly " $data"?: ProductItem_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductItem_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductItem_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "role",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a79a9a8bbd8ec35684592946e673034f";

export default node;
